var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.3633 13L12.1633 11.8M7.06328 12.4C7.81182 12.4 8.55302 12.2526 9.24458 11.9661C9.93613 11.6797 10.5645 11.2598 11.0938 10.7305C11.6231 10.2012 12.0429 9.57285 12.3294 8.8813C12.6158 8.18974 12.7633 7.44853 12.7633 6.7C12.7633 5.95147 12.6158 5.21026 12.3294 4.5187C12.0429 3.82715 11.6231 3.19879 11.0938 2.66949C10.5645 2.1402 9.93613 1.72034 9.24458 1.43389C8.55302 1.14743 7.81182 1 7.06328 1C5.55155 1 4.10173 1.60053 3.03277 2.66949C1.96382 3.73845 1.36328 5.18827 1.36328 6.7C1.36328 8.21173 1.96382 9.66155 3.03277 10.7305C4.10173 11.7995 5.55155 12.4 7.06328 12.4Z",
    stroke: "#1B1B1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.dd389b60d946dbacf75cddfbe4d484a4.svg";
export { ForwardRef as ReactComponent };